<template>
  <SimpleDataTable
      :clickable-title="true"
      :title="'Alış İrsaliyesi Raporu'"
      :description="''"
      :dataList="purchaseWaybillReportData"
      :dataHeaders="purchaseWaybillReportHeaders"
      :loading="purchaseWaybillReportDataLoading"
  >
    <template v-slot:filterAndAction>
      <v-select
          v-model="purchaseWaybillReportTimePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="purchaseWaybillReportTimePeriodFilterValue !== 5  ? _fetchPurchaseWaybillReport : null"
      >

      </v-select>
      <div v-if="purchaseWaybillReportTimePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(purchaseWaybillReportDateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                hide-details
                clearable
                @click:clear="purchaseWaybillReportDateRangeStartFilterValue = null"
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="purchaseWaybillReportDateRangeStartFilterValue"
              locale="tr"
              :max="purchaseWaybillReportDateRangeEndFilterValue ? purchaseWaybillReportDateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(purchaseWaybillReportDateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="purchaseWaybillReportDateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="purchaseWaybillReportDateRangeEndFilterValue"
              locale="tr"
              :min="purchaseWaybillReportDateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchPurchaseWaybillReport"
          >
            FİLTRELE
          </v-btn>
        </div>
      </div>
    </template>
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {mapState, mapActions} from "vuex";
import {numberConverter} from "../../../../helpers";
import {formattedDate} from "@/momentHelper";

export default {
  name: "AlisIrsaliyesiRaporu",
  components: {
    SimpleDataTable
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth",["user"])
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  mounted() {
    this._fetchPurchaseWaybillReport();
  },
  data(){
    return {
      purchaseWaybillReportHeaders:[],
      purchaseWaybillReportData:[],
      purchaseWaybillReportDataLoading: false,
      purchaseWaybillReportTimePeriodFilterValue: 4,
      purchaseWaybillReportDateRangeStartFilterValue: null,
      purchaseWaybillReportDateRangeEndFilterValue: null
    }
  },
  methods: {
    ...mapActions("dashboard",["fetchPurchaseReport","fetchCurrencyPurchaseReport"]),
    numberConverter,
    formattedDate,
    _fetchPurchaseWaybillReport(){

      this.purchaseWaybillReportDataLoading = true;

      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.purchaseWaybillReportTimePeriodFilterValue === "" || this.purchaseWaybillReportTimePeriodFilterValue == null)) && {DateType: this.purchaseWaybillReportTimePeriodFilterValue},
          Type: 4
        }
      }

      if (this.purchaseWaybillReportTimePeriodFilterValue === 5) {
        requestData.body.startDate = this.purchaseWaybillReportDateRangeStartFilterValue;
        requestData.body.endDate = this.purchaseWaybillReportDateRangeEndFilterValue;
      }

      this.fetchPurchaseReport(requestData).then(async (result) => {
        if(result && result.data.success)
        {
          this.purchaseWaybillReportData = [];
          this.purchaseWaybillReportData.push(result.data.data);
          this.purchaseWaybillReportData.map(item => item.vatExcludedAmount = this.numberConverter(item.vatExcludedAmount))
          this.purchaseWaybillReportData.map(item => item.vatExcludedCurrencyAmount = this.numberConverter(item.vatExcludedCurrencyAmount))
          this.purchaseWaybillReportHeaders =  [
            {
              key: 'vatExcludedAmount',
              label: 'Tutar (TL)',
              sortable: false,
            },
          ]
          if (this.erpSettings.netsisCurrencySale) {
            await this.fetchCurrencyPurchaseReport(requestData).then(async (result) => {
              if (!result) {
                this.purchaseReportDataLoading = false;
                return;
              }
              result.data.data.map((item) => {
                this.purchaseWaybillReportHeaders.push({
                  key: item.currencyName,
                  label: item.currencySymbol,
                  sortable: false,
                  class: 'text-center pe-4'
                })
                let keytemp = `${item.currencyName}`;
                item[keytemp] = item.vatExcludedAmount;
                delete item.vatExcludedAmount;
                let existingItem = this.purchaseWaybillReportData[0];
                if (existingItem) {
                  existingItem[item.currencyName] = this.numberConverter(item[keytemp]);
                } else {
                  let newObj = {
                    [item.currencyName]: item[keytemp]
                  };
                  this.purchaseWaybillReportData.push(newObj);
                }
              });
              this.purchaseWaybillReportData.push(result.data.data);
            })
          }
        }

        this.purchaseWaybillReportDataLoading = false;
      })
    }
  },
  watch :{
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchPurchaseWaybillReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchPurchaseWaybillReport()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchPurchaseWaybillReport()
    },
    purchaseWaybillReportTimePeriodFilterValue(newVal){
      if (newVal === 5) return;
      this._fetchPurchaseWaybillReport()
    },
  }
}
</script>

<style scoped>

</style>